import React, { useMemo } from 'react';
import type { SwampEvent } from '../types';
import { getTeamTheme, teamImageSrc } from '../teamTheme';
import { winningTeamNames } from '../scores';
import { WinnerCrown } from './WinnerCrown';

interface EventScoreCardProps {
   event: SwampEvent;
   teamNames: string[];
}

export function EventScoreCard({ event, teamNames }: EventScoreCardProps) {
   const winners = useMemo(
      () => winningTeamNames(event.scores),
      [event.scores]
   );

   return (
      <article className="swamp-event-card">
         <h3 className="swamp-event-card__title">{event.name}</h3>
         <p className="swamp-event-card__description">
            {event.description.split('\n').map((line, index, lines) => (
               <React.Fragment key={index}>
                  {line}
                  {index < lines.length - 1 && <br />}
               </React.Fragment>
            ))}
         </p>
         <ul className="swamp-score-rows">
            {teamNames.map((teamName) => {
               const theme = getTeamTheme(teamName);
               const imageSrc = teamImageSrc(teamName);
               const isWinner = winners.includes(teamName);

               return (
                  <li
                     key={teamName}
                     className="swamp-score-row"
                     style={{ borderColor: theme.color }}
                  >
                     {imageSrc && (
                        <img src={imageSrc} alt="" className="swamp-score-row__image" />
                     )}
                     <div className="swamp-score-row__details">
                        <span className="swamp-score-row__name" style={{ color: theme.color }}>
                           {teamName}
                           {isWinner && <WinnerCrown />}
                        </span>
                        {event.rounds?.[teamName] && (
                           <span className="swamp-score-row__rounds">
                              {event.rounds[teamName].join(' · ')}
                           </span>
                        )}
                     </div>
                     <span className="swamp-score-row__points">{event.scores[teamName] ?? 0}</span>
                  </li>
               );
            })}
         </ul>
      </article>
   );
}
